// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2SRFz","title":"Images90_title__1SA-K","images":"Images90_images__gjMQH"};